import type { Assignment, Group } from '@/hooks/useDashboardData';
import { assignmentStatusMap, getStatusMeta } from '@/lib/statusMap';
import StatusBadge from '@/components/base/StatusBadge';

interface PendingAssignmentsProps {
  assignments: Assignment[];
  groups: Group[];
}

function formatDeadline(deadline: string): string {
  const d = new Date(deadline);
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
}

export default function PendingAssignments({ assignments, groups }: PendingAssignmentsProps) {
  const pending = assignments.filter((a) => a.status === 'gonderildi' || a.status === 'goruldu');

  return (
    <div className="overflow-hidden rounded-xl border border-background-200 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[560px] text-left text-sm">
          <thead>
            <tr className="border-b border-background-200 bg-background-100/60 text-xs text-foreground-500">
              <th className="px-4 py-3 font-semibold">Grup</th>
              <th className="px-4 py-3 font-semibold">Ödev</th>
              <th className="px-4 py-3 font-semibold">Durum</th>
              <th className="px-4 py-3 font-semibold">Son Teslim</th>
            </tr>
          </thead>
          <tbody>
            {pending.length === 0 && (
              <tr>
                <td colSpan={4} className="px-4 py-6 text-center text-foreground-500">
                  Bekleyen ödev bulunmuyor.
                </td>
              </tr>
            )}
            {pending.map((a) => {
              const group = groups.find((g) => g.id === a.group_id);
              return (
                <tr key={a.id} className="border-b border-background-100 last:border-0 hover:bg-background-50">
                  <td className="px-4 py-3 font-medium text-foreground-900">{group?.name ?? '-'}</td>
                  <td className="px-4 py-3 text-foreground-700">{a.title}</td>
                  <td className="px-4 py-3">
                    <StatusBadge meta={getStatusMeta(a.status, assignmentStatusMap)} />
                  </td>
                  <td className="px-4 py-3 text-foreground-600">{formatDeadline(a.deadline)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}